import { Location } from "react-router";
import { ROUTES, industriesRoutes, mainRoutes, subRoutes } from "./navigation";

/**
 * Retrieves breadcrumb options based on the current location.
 * @param activeTab Active industry card tab.
 * @returns An array of breadcrumb options containing labels and hrefs.
 */
export const getBreadcrumbIndustryRoute = (activeTab: number) => {
  const industryTitle = industriesRoutes[activeTab].title;

  // Construct breadcrumb options based on the found routes and titles
  return [{ label: "Industries", href: "" }, { label: industryTitle }];
};

/**
 * Retrieves breadcrumb options based on the current location.
 * @param location The location object from React Router.
 * @returns An array of breadcrumb options containing labels and hrefs.
 */
export const getBreadcrumbRoute = (location: Location) => {
  // Splitting the pathname to get individual segments
  const segments = location.pathname.split("/");

  // Find main Route
  const mainRoute = mainRoutes.find((route) =>
    route.path.includes(segments[1])
  );

  // Find sub Route
  const subRoute = subRoutes.find((route) => route.path.includes(segments[2]));

  if (mainRoute && segments[2] === ROUTES.trackingDevices.split("/")[2]) {
    return [
      { label: mainRoute.title, href: mainRoute.path },
      { label: subRoute?.title || segments[2] },
      { label: "device name" },
    ];
  }

  if (mainRoute && segments[2]) {
    return [
      { label: mainRoute.title, href: mainRoute.path },
      { label: subRoute?.title || segments[2] },
    ];
  }

  if (mainRoute && segments[1]) {
    return [{ label: mainRoute.title }];
  }

  return [{ label: "Home", href: "/" }];
};

/**
 * Retrieves breadcrumb options based on the current location.
 * @param location The location object from React Router.
 * @param productName The name of opened product page.
 * @returns An array of breadcrumb options containing labels and hrefs.
 */
export const getBreadcrumbDeviceRoute = (
  location: Location,
  productName: string
) => {
  // Splitting the pathname to get individual segments
  const segments = location.pathname.split("/");

  // Find main Route
  const mainRoute = mainRoutes.find((route) =>
    route.path.includes(segments[1])
  );

  // Find sub Route
  const subRoute = subRoutes.find((route) => route.path.includes(segments[2]));

  if (mainRoute && subRoute) {
    return [
      { label: mainRoute.title, href: mainRoute.path },
      {
        label: subRoute?.title || segments[2],
        href: subRoute.path.includes("/solutions/devices")
          ? mainRoute.path
          : subRoute.path,
      },
      { label: productName },
    ];
  }

  return [{ label: "Home", href: "/" }];
};

export const getBreadcrumbArticleRoute = (location: Location) => {
  // Splitting the pathname to get individual segments
  const segments = location.pathname.split("/");

  // Find main Route
  const mainRoute = mainRoutes.find((route) =>
    route.path.includes(segments[1])
  );

  // Find sub Route
  const subRoute = subRoutes.find((route) => route.path.includes(segments[2]));

  if (mainRoute && subRoute) {
    return [
      { label: mainRoute.title, href: mainRoute.path },
      { label: subRoute.title || segments[2], href: subRoute.path },
    ];
  }

  return [{ label: "Home", href: "/" }];
};
